import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

/**
 * ------------------------------------------------------------------
 * INFOS ASSOCIATION (à sortir dans un fichier de config si besoin)
 * ------------------------------------------------------------------
 */
const CLUB = {
  name: "Cercle Gymnique Villeneuvois",
  subtitle: "Complexe de la Myre Mory",
  address: "47300 VILLENEUVE SUR LOT",
  email: "c.g.v.gym@wanadoo.fr",
  website: "cgv-gym.sportsregions.fr",
  siret: "351 622 444 00021",
  logoPath: "https://res.cloudinary.com/dkz9knsgj/image/upload/v1788964162/logo_cgv_oaid07.png",
};

/**
 * ------------------------------------------------------------------
 * STYLES
 * ------------------------------------------------------------------
 */
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "#1a1a1a",
  },

  // --- Header ---
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  },
  logo: {
    width: 130,
    height: "auto",
  },
  clubInfo: {
    width: 220,
    textAlign: "right",
    fontSize: 9,
    lineHeight: 1.5,
    color: "#333",
  },
  clubName: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
    marginBottom: 6,
    color: "#000",
    textAlign: "right",
  },

  // --- Date ---
  dateRow: {
    textAlign: "right",
    marginBottom: 20,
    fontSize: 10,
  },

  // --- Title ---
  title: {
    fontSize: 15,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: 30,
  },

  // --- Bloc adhérent ---
  userBlock: {
    marginBottom: 18,
  },
  seasonLabel: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
    marginBottom: 6,
  },
  userLine: {
    flexDirection: "row",
    fontSize: 10,
  },
  userLine2: {
    flexDirection: "row",
    fontSize: 10,
    marginTop: 3,
  },
  userLineLabel: {
    fontFamily: "Helvetica-Bold",
    marginRight: 4,
  },

  // --- Titres de section ---
  sectionTitle: {
    fontSize: 10,
    fontFamily: "Helvetica-Bold",
    marginTop: 14,
    marginBottom: 6,
    textTransform: "uppercase",
    color: "#000",
  },

  // --- Tableau générique ---
  table: {
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 4,
  },
  tableHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ccc",
    minHeight: 22,
  },
  tableRowLast: {
    flexDirection: "row",
    minHeight: 22,
  },
  headerCellText: {
    fontFamily: "Helvetica-Bold",
    fontSize: 9,
  },

  // colonnes tableau "cotisation"
  colDesignation: { flex: 3, padding: 6, borderRightWidth: 1, borderColor: "#000", justifyContent: "center" },
  colTarif: { flex: 1, padding: 6, borderRightWidth: 1, borderColor: "#000", justifyContent: "center", textAlign: "center" },
  colTotal: { flex: 1, padding: 6, justifyContent: "center", textAlign: "center" },

  // colonnes tableau "paiements / remboursements"
  colMethod: { flex: 2, padding: 6, borderRightWidth: 1, borderColor: "#000", justifyContent: "center" },
  colDate: { flex: 1, padding: 6, borderRightWidth: 1, borderColor: "#000", justifyContent: "center", textAlign: "center" },
  colMotif: { flex: 2, padding: 6, borderRightWidth: 1, borderColor: "#000", justifyContent: "center" },
  colAmount: { flex: 1, padding: 6, justifyContent: "center", textAlign: "center" },

  cellText: { fontSize: 9 },
  discountText: { fontSize: 9, color: "#a30000" },

  // --- Récapitulatif ---
  recapBlock: {
    marginTop: 16,
    alignSelf: "flex-end",
    width: 240,
  },
  recapRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 3,
  },
  recapLabel: {
    fontSize: 10,
  },
  recapValue: {
    fontSize: 10,
  },
  recapDivider: {
    borderTopWidth: 1,
    borderColor: "#000",
    marginVertical: 4,
  },
  recapTotalLabel: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
  },
  recapTotalValue: {
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
  },

  // --- Acquittement ---
  acquitBlock: {
    marginTop: 28,
  },
  acquitText: {
    fontSize: 10,
    marginBottom: 4,
  },
  signatureRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 26,
  },
  signatureBox: {
    width: 180,
    borderTopWidth: 1,
    borderColor: "#999",
    paddingTop: 4,
    fontSize: 8,
    color: "#555",
    textAlign: "center",
  },

  // --- Mentions légales ---
  legalBlock: {
    position: "absolute",
    bottom: 30,
    left: 40,
    right: 40,
    borderTopWidth: 1,
    borderColor: "#ccc",
    paddingTop: 8,
  },
  legalText: {
    fontSize: 7,
    color: "#666",
    lineHeight: 1.4,
    marginBottom: 2,
  },
  docNumber: {
    fontSize: 8,
    color: "#999",
    marginTop: 4,
  },
});

/**
 * ------------------------------------------------------------------
 * UTILS
 * ------------------------------------------------------------------
 */
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const formatAmount = (amount) => {
  const value = Number(amount) || 0;
  return `${value.toFixed(2).replace(".", ",")} €`;
};

/**
 * ------------------------------------------------------------------
 * COMPOSANT PRINCIPAL
 * ------------------------------------------------------------------
 *
 * Props attendues :
 * - user: { last_name, first_name, birth_date, legal_tutors }
 * - season: { label }                        ex: "2026/2027"
 * - tarif: { label, amount }                  la cotisation de base
 * - discount: number                          remise en €
 * - payments: [{ method, amount, date }]      liste des paiements effectués
 * - refunds: [{ method, amount, date, motif }] liste des remboursements
 * - overpayments: [{ amount, motif }]         trop perçus non remboursés
 * - payeur: { last_name, first_name, email }  personne qui règle (éditable dans la modal),
 *                                              si absent on retombe sur le 1er représentant légal
 * - documentDate: Date | string               date d'émission du document
 * - docNumber: string                         ex: "JP-2026-0042" (optionnel)
 */
export default function JustificatifPaiementPDF({
  user,
  season,
  tarif,
  discount = 0,
  payments = [],
  refunds = [],
  overpayments = [],
  payeur = null,
  documentDate = new Date(),
  docNumber = "",
}) {
  const defaultTutor = user?.legal_tutors?.[0];
  const displayPayeur = payeur || {
    last_name: defaultTutor?.tutor_last_name,
    first_name: defaultTutor?.tutor_first_name,
  };

  const tarifAmount = Number(tarif?.amount) || 0;
  const discountAmount = Number(discount) || 0;
  const amountDue = tarifAmount - discountAmount;

  const totalPaid = payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
  const totalRefunded = refunds.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
  const totalOverpaid = overpayments.reduce((sum, o) => sum + (Number(o.amount) || 0), 0);
  const balance = amountDue - totalPaid + totalRefunded;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View style={styles.headerRow}>
          <Image src={CLUB.logoPath} style={styles.logo} />
          <View style={styles.clubInfo}>
            <Text style={styles.clubName}>{CLUB.name}</Text>
            <Text>{CLUB.subtitle}</Text>
            <Text>{CLUB.address}</Text>
            <Text>E-mail : {CLUB.email}</Text>
            <Text>Site internet : {CLUB.website}</Text>
            <Text>N° siret : {CLUB.siret}</Text>
          </View>
        </View>

        {/* DATE */}
        <View style={styles.dateRow}>
          <Text>Le {formatDate(documentDate)}</Text>
        </View>

        {/* TITRE */}
        <Text style={styles.title}>Justificatif de paiement</Text>

        {/* BLOC ADHÉRENT */}
        <View style={styles.userBlock}>
          <Text style={{...styles.seasonLabel, marginBottom: 12 }}>SAISON {season?.label ?? ""}</Text>

          {(displayPayeur?.last_name || displayPayeur?.first_name) && (
            <View style={styles.userLine2}>
              <Text style={styles.userLineLabel}>Représentant légal :</Text>
              <Text>
                {displayPayeur.last_name?.toUpperCase()} {displayPayeur.first_name}
              </Text>
            </View>
          )}

          <View style={{...styles.userLine2, marginTop: 10 }}>
            <Text style={styles.userLineLabel}>Nom, prénom de l'adhérent :</Text>
            <Text>
              {user?.last_name?.toUpperCase()} {user?.first_name}
            </Text>
          </View>
          <View style={styles.userLine2}>
            <Text style={styles.userLineLabel}>Date de naissance :</Text>
            <Text>{formatDate(user?.birth_date)}</Text>
          </View>
        </View>

        {/* COTISATION / REMISE */}
        <Text style={styles.sectionTitle}>Cotisation</Text>
        <View style={styles.table}>
          <View style={styles.tableHeaderRow}>
            <View style={styles.colDesignation}>
              <Text style={styles.headerCellText}>Désignation</Text>
            </View>
            <View style={styles.colTarif}>
              <Text style={styles.headerCellText}>Tarif</Text>
            </View>
            <View style={styles.colTotal}>
              <Text style={styles.headerCellText}>Montant</Text>
            </View>
          </View>

          <View style={discountAmount > 0 ? styles.tableRow : styles.tableRowLast}>
            <View style={styles.colDesignation}>
              <Text style={styles.cellText}>{tarif?.label || "Cotisation"}</Text>
            </View>
            <View style={styles.colTarif}>
              <Text style={styles.cellText}>{formatAmount(tarifAmount)}</Text>
            </View>
            <View style={styles.colTotal}>
              <Text style={styles.cellText}>{formatAmount(tarifAmount)}</Text>
            </View>
          </View>

          {discountAmount > 0 && (
            <View style={styles.tableRowLast}>
              <View style={styles.colDesignation}>
                <Text style={styles.discountText}>Remise</Text>
              </View>
              <View style={styles.colTarif}>
                <Text style={styles.discountText}>−{formatAmount(discountAmount)}</Text>
              </View>
              <View style={styles.colTotal}>
                <Text style={styles.discountText}>−{formatAmount(discountAmount)}</Text>
              </View>
            </View>
          )}
        </View>

        {/* DÉTAIL DES PAIEMENTS */}
        {payments.length > 0 && (
          <>
            <Text style={styles.sectionTitle}>Détail des paiements</Text>
            <View style={styles.table}>
              <View style={styles.tableHeaderRow}>
                <View style={styles.colMethod}>
                  <Text style={styles.headerCellText}>Méthode</Text>
                </View>
                <View style={styles.colDate}>
                  <Text style={styles.headerCellText}>Date</Text>
                </View>
                <View style={styles.colAmount}>
                  <Text style={styles.headerCellText}>Montant</Text>
                </View>
              </View>
              {payments.map((p, i) => (
                <View
                  style={i === payments.length - 1 ? styles.tableRowLast : styles.tableRow}
                  key={`payment-${i}`}
                >
                  <View style={styles.colMethod}>
                    <Text style={styles.cellText}>{p.method}</Text>
                  </View>
                  <View style={styles.colDate}>
                    <Text style={styles.cellText}>{formatDate(p.date)}</Text>
                  </View>
                  <View style={styles.colAmount}>
                    <Text style={styles.cellText}>{formatAmount(p.amount)}</Text>
                  </View>
                </View>
              ))}
            </View>
          </>
        )}

        {/* DÉTAIL DES REMBOURSEMENTS */}
        {refunds.length > 0 && (
          <>
            <Text style={styles.sectionTitle}>Remboursements</Text>
            <View style={styles.table}>
              <View style={styles.tableHeaderRow}>
                <View style={styles.colMethod}>
                  <Text style={styles.headerCellText}>Méthode</Text>
                </View>
                <View style={styles.colDate}>
                  <Text style={styles.headerCellText}>Date</Text>
                </View>
                <View style={styles.colMotif}>
                  <Text style={styles.headerCellText}>Motif</Text>
                </View>
                <View style={styles.colAmount}>
                  <Text style={styles.headerCellText}>Montant</Text>
                </View>
              </View>
              {refunds.map((r, i) => (
                <View
                  style={i === refunds.length - 1 ? styles.tableRowLast : styles.tableRow}
                  key={`refund-${i}`}
                >
                  <View style={styles.colMethod}>
                    <Text style={styles.cellText}>{r.method}</Text>
                  </View>
                  <View style={styles.colDate}>
                    <Text style={styles.cellText}>{formatDate(r.date)}</Text>
                  </View>
                  <View style={styles.colMotif}>
                    <Text style={styles.cellText}>{r.motif || "—"}</Text>
                  </View>
                  <View style={styles.colAmount}>
                    <Text style={styles.cellText}>{formatAmount(r.amount)}</Text>
                  </View>
                </View>
              ))}
            </View>
          </>
        )}

        {/* TROP PERÇUS */}
        {overpayments.length > 0 && (
          <>
            <Text style={styles.sectionTitle}>Trop perçu non remboursé</Text>
            <View style={styles.table}>
              <View style={styles.tableHeaderRow}>
                <View style={styles.colMotif}>
                  <Text style={styles.headerCellText}>Motif</Text>
                </View>
                <View style={styles.colAmount}>
                  <Text style={styles.headerCellText}>Montant</Text>
                </View>
              </View>
              {overpayments.map((o, i) => (
                <View
                  style={i === overpayments.length - 1 ? styles.tableRowLast : styles.tableRow}
                  key={`overpayment-${i}`}
                >
                  <View style={styles.colMotif}>
                    <Text style={styles.cellText}>{o.motif || "—"}</Text>
                  </View>
                  <View style={styles.colAmount}>
                    <Text style={styles.cellText}>{formatAmount(o.amount)}</Text>
                  </View>
                </View>
              ))}
            </View>
          </>
        )}

        {/* RÉCAPITULATIF */}
        <View style={styles.recapBlock}>
          <View style={styles.recapRow}>
            <Text style={styles.recapLabel}>Montant dû</Text>
            <Text style={styles.recapValue}>{formatAmount(amountDue)}</Text>
          </View>
          <View style={styles.recapRow}>
            <Text style={styles.recapLabel}>Total payé</Text>
            <Text style={styles.recapValue}>{formatAmount(totalPaid)}</Text>
          </View>
          {totalRefunded > 0 && (
            <View style={styles.recapRow}>
              <Text style={styles.recapLabel}>Total remboursé</Text>
              <Text style={styles.recapValue}>{formatAmount(totalRefunded)}</Text>
            </View>
          )}
          {totalOverpaid > 0 && (
            <View style={styles.recapRow}>
              <Text style={styles.recapLabel}>Trop perçu</Text>
              <Text style={styles.recapValue}>{formatAmount(totalOverpaid)}</Text>
            </View>
          )}
          <View style={styles.recapDivider} />
          <View style={styles.recapRow}>
            <Text style={styles.recapTotalLabel}>Solde</Text>
            <Text style={styles.recapTotalValue}>{formatAmount(balance)}</Text>
          </View>
        </View>

        {/* ACQUITTEMENT */}
        <View style={styles.acquitBlock}>
          <Text style={styles.acquitText}>
            {balance <= 0
              ? "Facture acquittée, réglée intégralement."
              : "Facture partiellement réglée."}
          </Text>
          <Text style={styles.acquitText}>
            Association loi 1901, non assujettie à la TVA
          </Text>
          <Text style={styles.acquitText}>le {formatDate(documentDate)}</Text>

          {/* <View style={styles.signatureRow}>
            <View style={styles.signatureBox}>
              <Text>Cachet de l'association</Text>
            </View>
            <View style={styles.signatureBox}>
              <Text>Signature</Text>
            </View>
          </View> */}
        </View>

        {/* MENTIONS LÉGALES */}
        <View style={styles.legalBlock} fixed>
          <Text style={styles.legalText}>
            TVA non applicable, article 293 B du Code général des impôts —
            association loi 1901 à but non lucratif. Ce document tient lieu de justificatif de paiement et ne
            constitue pas une facture au sens fiscal du terme. Reçu pour solde de tout compte à la date d'émission mentionnée
            ci-dessus.
          </Text>
          {docNumber ? (
            <Text style={styles.docNumber}>Référence : {docNumber}</Text>
          ) : null}
        </View>
      </Page>
    </Document>
  );
}